"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    function isObservableArray(value) {
        return value && value.__isObservableArray ? true : false;
    }
    $dyn.isObservableArray = isObservableArray;
    function observableArray(value) {
        return (new $dyn.observableArray._ObservableHost(value))._observable;
    }
    $dyn.observableArray = observableArray;
    (function (observableArray) {
        // tslint:disable-next-line:variable-name
        observableArray._arrayMethods = ["pop", "push", "shift", "reverse", "sort", "splice", "unshift"];
        // tslint:disable-next-line:class-name
        var _ObservableHost = /** @class */ (function (_super) {
            __extends(_ObservableHost, _super);
            function _ObservableHost(value) {
                var _this = _super.call(this, value) || this;
                _this._observable.__isObservableArray = true;
                _this._observable.__array = [];
                Object.defineProperty(_this._observable, "len", {
                    get: function () {
                        return this.__array.length;
                    },
                });
                Object.defineProperty(_this._observable, "_current", {
                    get: function () { return this.__array; },
                    set: function (newVal) {
                        if (!newVal) {
                            this.__array.length = 0;
                        }
                        else {
                            var len = newVal.length;
                            this.__array.length = len;
                            for (var i = 0; i < len; i++) {
                                this.__array[i] = newVal[i];
                            }
                        }
                    },
                });
                $dyn.observableArray._arrayMethods.forEach(function (item) {
                    _this._observable[item] = function () {
                        var array = this._observable.__array;
                        var result = array[item].apply(array, arguments);
                        this._observable.valueChanged.raise();
                        return result;
                    }.bind(_this);
                });
                _this._observable.setAt = function (index, val) {
                    var array = _this._observable.__array;
                    var result = array[index] = val; // if there is an error, it won't get passed back... need a try catch?
                    _this.raise();
                    return result;
                };
                _this._observable.clear = function () {
                    var array = _this._observable.__array;
                    array.length = 0;
                    _this.raise();
                };
                _this._observable.swap = function (index1, index2) {
                    var array = _this._observable.__array;
                    var temp = array[index1];
                    array[index1] = array[index2];
                    array[index2] = temp;
                    _this.raise();
                };
                _this._observable._current = value;
                return _this;
            }
            return _ObservableHost;
        }($dyn.observable._ObservableHost));
        observableArray._ObservableHost = _ObservableHost;
    })(observableArray = $dyn.observableArray || ($dyn.observableArray = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ObservableArray.js.map
